<template>
  <el-drawer
    class="e-drawer"
    :with-header="false"
    :visible.sync="selfShow"
    :size="size"
    :append-to-body="appendToBody"
    :wrapper-closable="wrapperClosable"
  >
    <div class="e-drawer__container">
      <div class="e-drawer__header">
        <slot name="header">
          <div class="e-drawer__title">{{ title }}</div>
        </slot>
        <span class="e-drawer__close" title="关闭" @click="closeDrawer">
          <i class="el-icon-close f-s-20"></i>
        </span>
      </div>

      <div class="e-drawer__body box-y-scroll">
        <div class="e-drawer__content">
          <slot />
        </div>
      </div>

      <div v-if="showFooter" class="e-drawer__footer">
        <slot name="footer" />
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'EDrawer',
  props: {
    // 是否显示 Drawer 组件
    show: {
      type: Boolean,
      default: false
    },
    // Drawer 组件的宽度或高度，取决于 placement 的值
    size: {
      type: String,
      default: '80%'
    },
    // Drawer 组件的标题
    title: {
      type: String,
      default: ''
    },
    // 是否将 Drawer 组件的 DOM 元素插入到 body 中
    appendToBody: {
      type: Boolean,
      default: true
    },
    // 点击遮罩层是否关闭 Drawer 组件
    wrapperClosable: {
      type: Boolean,
      default: false
    },
    // 是否显示底部区域
    showFooter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: this.show
    }
  },
  methods: {
    closeDrawer() {
      this.selfShow = false
      this.$emit('close')
    }
  },
  watch: {
    show(val) {
      this.selfShow = val
    },
    selfShow(val) {
      this.$emit('update:show', val)
    }
  }
}
</script>

<style scoped lang="less">
.e-drawer {
  display: flex;
  flex-direction: column;
  height: 100%;
  /deep/ .el-drawer__body {
    position: relative;
    overflow-y: inherit;
  }
  .e-drawer__container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    .e-drawer__header {
      flex: 0 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      height: 49px;
      padding: 10px;
      border-bottom: 1px solid #ebeef5;
      .e-drawer__title {
        font-size: 16px;
        font-weight: bold;
      }
      .e-drawer__close {
        margin-left: 12px;
        cursor: pointer;
        color: #909399;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      .e-drawer__close:hover {
        color: #606266;
      }
    }
    .e-drawer__body {
      display: flex;
      flex-direction: column;
      flex: 1;
      .e-drawer__content {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding: 10px;
      }
    }
    .e-drawer__footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      height: 49px;
      padding: 10px;
      background: #fff;
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
